import { Link } from "@mui/material";
import { HiOutlineTicket } from "react-icons/hi";
import { MdOutlineEventSeat, MdOutlinedFlag } from "react-icons/md";
import { TbShirtSport } from "react-icons/tb";
import { mlbUrls } from "../../mlb_urls";

export const howItWorks = [
  {
    icon: <MdOutlinedFlag />,
    title: "Choose Your Games",
    description:
      "Select a Premium Game and get a Regular Season game for just $5!",
  },
  {
    icon: <MdOutlineEventSeat />,
    title: "Login to MLB.com",
    description: (
      <>
        Click Continue and connect your Oakland Athletics account using our
        secure{" "}
        <Link target="_blank" href="https://www.mlb.com/">
          MLB.com
        </Link>{" "}
        login.
      </>
    ),
  },
  {
    icon: <TbShirtSport />,
    title: "Select Your Seats",
    description: "Select the seats you wish to purchase for each game.",
  },

  {
    icon: <HiOutlineTicket />,
    title: "Get Your Tickets",
    description:
      "Tickets will be available in your Oakland Athletics account within 24 hours of redemption. Reach out to Live Fan Support for any questions.",
  },
];

export const faqs = [
  {
    title: "How does the Oakland Athletics Flex program work?",
    description:
      "The Oakland Athletics Flex program allows fans to select any Premium Game and purchase any Regular Season game for $5! Simply begin selecting games that you would like to attend and you will be prompted to select seats.",
  },
  {
    title: "Do I have to select all my games now?",
    description:
      "To be eligible for the promotion, you must select all Promotional and Regular season games at the same time.",
  },
  {
    title: "Can I choose seats throughout the venue?",
    description:
      "After you select games, you will be prompted to select from available inventory for those seats.",
  },
  {
    title: "Where are tickets delivered?",
    description:
      "Tickets are delivered directly within your Oakland Athletics Account.",
  },
];

export function TermsAndCondition() {
  return (
    <>
      By checking this box you agree to receive SMS alerts regarding ticket
      delivery and agree to the Oakland Athletics{" "}
      <Link
        href={"https://www.mlb.com/athletics"}
        target={"_blank"}
        sx={{
          color: "primary.main",
          textDecoration: "none",
          fontWeight: 500,
        }}
      >
        Ticket Terms & Conditions
      </Link>
      ,{" "}
      <Link
        href={
          "https://uploads-ssl.webflow.com/5ed7df6fe67e862e0a62f9f2/616882d2b691e09f75348396_Terms%20%26%20Conditions.pdf"
        }
        target={"_blank"}
        sx={{
          color: "primary.main",
          textDecoration: "none",
          fontWeight: 500,
        }}
      >
        Terms & Conditions
      </Link>{" "}
      and{" "}
      <Link
        href={
          "https://uploads-ssl.webflow.com/5ed7df6fe67e862e0a62f9f2/63c05d80816dac05b5b34ac7_seasonshare%20CCPA%20Privacy%20Policy%20Agreement.pdf"
        }
        target={"_blank"}
        sx={{
          color: "primary.main",
          textDecoration: "none",
          fontWeight: 500,
        }}
      >
        Privacy Policy
      </Link>
      .
    </>
  );
}

export function CheckoutTermsAndCondition() {
  return (
    <>
      In connection with your purchase, you will receive ticket-related
      commercial emails from athletics.com. You may unsubscribe at any time. By
      checking this box you agree to receive additional commercial emails from
      athletics.com and MLB.com
      <br />
      <br />
      Upon completing your purchase by selecting Checkout you acknowledge and
      agree that your credit card will be charged.
      <br />
      <br />
      By clicking &quot;Checkout&quot;, you agree to the{" "}
      <Link
        href={mlbUrls.privacyPolicy}
        target={"_blank"}
        sx={{
          color: "primary.main",
          textDecoration: "none",
          fontWeight: 500,
        }}
      >
        MLB Privacy Policy
      </Link>
      ,{" "}
      <Link
        href={mlbUrls.termsOfUse}
        target={"_blank"}
        sx={{
          color: "primary.main",
          textDecoration: "none",
          fontWeight: 500,
        }}
      >
        Terms of Use
      </Link>{" "}
      and to receive your ticket(s) via an SMS text message to the mobile #
      associated with your Athletics account. Messaging and data rates may
      apply. Tickets will be made available in the MLB Ballpark mobile
      application only. MLB.com and supported mobile device required.
    </>
  );
}
